import React from "react";

const MetadataTable = ({ metadata }) => {
  if (!metadata) return <p>No metadata available.</p>;

  return (
    <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "1rem" }}>
      <thead>
        <tr>
          <th style={{ border: "1px solid #ccc", padding: "8px",background:"#333" }}>Field</th>
          <th style={{ border: "1px solid #ccc", padding: "8px",background:"#333" }}>Value</th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(metadata).map(([key, value], i) => (
          <tr key={i}>
            <td style={{ border: "1px solid #ccc", padding: "8px", fontWeight: "bold" }}>{key || i + 1}</td>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>{value || "N/A"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default MetadataTable;
